import { useActiveOrg } from "@/features/organizations/hooks/use-active-org";

/**
 * `organization_id` activo para el scope del inventario — el ÚNICO punto por el
 * que pasa el scope del WMS.
 *
 * Multi-organización: devuelve el id de la empresa/supermercado ACTIVO (elegido
 * en el switcher), o el userId cuando el scope activo es Personal (inventario
 * personal F1 / modo visitante con `VISITOR_ID`). Como todas las rutas del WMS
 * (catálogo, almacenes, existencias, operaciones, compras, conteos, lotes,
 * fabricación, valoración, reabastecimiento, dashboard, papelera) derivan de
 * este accessor, un cambio de organización re-scopea TODO reactivamente sin
 * recargar ni prop-drilling.
 *
 * El scope se valida contra las orgs sincronizadas en local (auto-sanación:
 * cae a Personal si el puntero quedó viejo), así que nunca queda apuntando a
 * una org inexistente que dejaría el inventario vacío para siempre.
 */
export function useOrgId(): () => string {
  const { activeScopeId } = useActiveOrg();
  return activeScopeId;
}
